import React from 'react';
import { Flyer } from '../../definitions/FlyerDefinitions';
import { useRouter } from 'next/router';
import { LOCATION_FOR_BOT } from '../../hooks/useLocationDetect';
import { getFlyersCategoriesSlugToNameMapping } from '../../helpers/categories';
import Head from 'next/head';
import { getAmpUrl } from '../../helpers/links';
import Breadcrumbs from '../breadcrumbs';
import { getBreadcrumbsData } from '../../helpers/breadcrumbs';
import FlyerList from '../flyerList';
import Footer from '../footer';
import { DataJSON } from '../../definitions/BackflippDefinitions';
import { isRuntimeSDE } from '../../hooks/useConfig';

export interface FlyersListPageProps {
  data: DataJSON;
  postalCode: string;
}

export function FlyerListPage({ data, postalCode }: FlyersListPageProps): JSX.Element {
  const router = useRouter();

  const locationFromQuery = router.query['location'] as string;
  const location = locationFromQuery ? locationFromQuery : LOCATION_FOR_BOT[router.locale].location;
  const categoryName = router.query['category'] as string;
  const category = categoryName ? getFlyersCategoriesSlugToNameMapping()[categoryName] : 'All Flyers';
  const flyers = data.flyers.map((flyer) => new Flyer(flyer));

  if (isRuntimeSDE()) {
    return (
      <FlyerList
        flyers={flyers}
        location={location}
        category={category}
        postalCode={postalCode}
        shouldRenderTopBar={false}
      />
    );
  }

  return (
    <>
      <Head>{category === 'All Flyers' && <link rel="amphtml" href={getAmpUrl(router)} />}</Head>
      <Breadcrumbs breadcrumbs={getBreadcrumbsData(router)} />
      <FlyerList
        flyers={flyers}
        location={location}
        category={category}
        postalCode={postalCode}
        shouldRenderTopBar={true}
      />
      <Footer />
    </>
  );
}
